export const DEFAULT_COLOR = '#000000' // Black
export const PRIMARY_COLOR = '#005a7c' // Blue
export const GREEN_60_COLOR = '#C0DAB0'
export const GREEN_90_COLOR = '#66B786'

export const DEFAULT_SIZE = 24

export const DEFAULT_STROKE_WIDTH = '2'